const ROOT = 'current-user'

export const QUERY_KEYS = {
  profile: [ROOT, 'profile'] as const,
  permissions: [ROOT, 'permissions'] as const,
}
